import { DateUtils } from "@repo/common"
import { cn } from "@repo/ui/lib/utils"
import { CornerDownRight } from "lucide-react"
import * as React from "react"
import { useTranslations } from "use-intl"

interface ProductOrderingIndicatorProps {
  expectedDeliveryDate?: string | null
  className?: string
}

const ProductOrderingIndicator = React.forwardRef<
  HTMLDivElement,
  ProductOrderingIndicatorProps
>(({ expectedDeliveryDate, className }, ref) => {
  const t = useTranslations("ui")
  const deliveryDate = expectedDeliveryDate
    ? new Date(expectedDeliveryDate)
    : null

  return (
    <div
      ref={ref}
      className={cn(
        "flex flex-col gap-0.5 rounded-lg border border-border bg-background px-2.5 py-1.5 text-xs text-info-foreground",
        className,
      )}
    >
      <div className="flex items-center gap-1.5 font-semibold">
        <CornerDownRight className="size-3.5 shrink-0" />
        <span>{t("juloProductInput.needsOrdering")}</span>
      </div>
      {deliveryDate && (
        <span className="ml-5">
          {t("proposalForm.deliveryLine", {
            time: DateUtils.formatDeliveryTime(deliveryDate),
            date: DateUtils.prettyPrintDate(deliveryDate),
          })}
        </span>
      )}
    </div>
  )
})

ProductOrderingIndicator.displayName = "ProductOrderingIndicator"

export { ProductOrderingIndicator, type ProductOrderingIndicatorProps }
